import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Company } from "../models/company";
import { CompanyService } from "../services/company.service";
import { Observable } from "rxjs";

@Injectable()
export class CompaniesResolver implements Resolve<Company[]> {
    constructor(private companyService: CompanyService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<Company[]> {
        return this.companyService.getAll();
    }
}
